<sm-title-bar [customBackforemployee]="true" pageTitle="Select a pack" *ngIf="!loader" >
</sm-title-bar>
<!-- pageSubTitle="To continue, you have to select an employee pack first. It can be a Free or paid one- based on your preference." -->
<div class="price_part_lookz" *ngIf="!loader">
    <div class="create_opl">
        <div class="pricingtable-row hair-membership">
            <div class="row" style="margin-bottom: 50px; align-items: center;">
                <!-- <div class="col-sm-12">
                    <div class="subscription_hedinghj">
                        <h3>Select an employee pack</h3>
                        <p>To continue, you have to select an employee pack first. It can be a Free or paid one- based on your preference.</p>
                    </div>
                </div> -->
   <!-- Static Plan 2 -->
   <div class="col-sm-6 col-md-4 col-lg-4 m-b30" *ngFor="let item of plansList ; let i = index">
    <div class="price_card_aft" [ngStyle]="{border: item.selected == true ? '2px solid #ffc107' : ''}">
       <div class="pricingtable-wrapper">
         <div class="popular_cdf" *ngIf="item.validity_count == 365">
            <span class="rotated-text">Popular</span>   
           </div>
          <div class="pricingtable-inner">
             <div class="grp_heda">
                <h3>{{item.title}}</h3>
                <p> {{item.perUnitCost == 0 ? 'Standard support & troubleshoot' : 'Premium support & troubleshoot' }} 
                </p>
             </div>
             <div class="pricingtable-price"> <span class="pricingtable-bx">{{item.currency_symbol}}{{item.perUnitCost.toFixed(2)}}</span> </div>
             <ul class="pricingtable-features">
                <li class="tcv_head">
                  {{item.perUnitCost == 0 ? '5 employees' : '1 employee'}}
                </li>
                <li>
                  {{ item.validity_count }} days validity
                </li>
             </ul>
             <div class="pricingtable-price" style="border-top: 1px solid #efefef;padding-top: 10px;">
                <ul class="pricingtable-features">
                    <li>
                        {{item.perUnitCost == 0 ? '* Add/recharge 5 employees for 30 days.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Add/recharge 1 employee for 30 days.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Add/recharge 1 employee for 1 year.' : 'N/A')}} 
                      </li>
                      <li>
                        {{item.perUnitCost == 0 ? '* Pack is valid with active paid or free trial  business.' : (item.perUnitCost > 0 && item.validity_count == 30 ? '* Opt in option for multiple employees and months at once.' : item.perUnitCost > 0 && item.validity_count == 365 ? '* Opt in option for multiple employees at once.' : 'N/A')}} 
                      </li>
                </ul>
             </div>
          </div>
          <div class="price_button" [ngClass]="{'seletedbtn': item.selected ==  true}">
         
             <button [disabled]="item.isExpired == 1" (click)="selectPlan(i)" type="button"><mat-icon *ngIf="item.selected ==  true">check</mat-icon> {{item.selected ==  true ? 'Selected' : 'Select Pack'}} </button>
          </div>
          
       </div>
    </div>
 </div>
            </div>
        </div>

       
    
        <div class="likely_section" #bottomElement>
            <mat-card appearance="outlined" *ngIf="selectedPlan && selectedPlan != 'null'">
             <!-- ------------- 30 days employee pack --------------------- -->
              <div class="row" *ngIf="selectedPlan.perUnitCost > 0 && selectedPlan.validity_count == 30">
                <div class="col-sm-7">
                    <div class="create_employees_ben">
                        
                    </div>
                </div>
                 <div class="col-sm-5">
                    <div class="choose_sucri emsection">
                          <div class="nus_nu_sectionm">
                            <div class="create_thy">
                             <h3>{{selectedPlan.title}}</h3>
                             <!-- <p class="prev_heading">Premium support & troubleshoot</p> -->
                             <p>You have the liberty to choose up to 11 months of pack at once. Also you can buy this pack for any number of employees.</p>
                            </div>
                             <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                             <h4>per employee for 30 days</h4>
                             <!-- <p>{{selectedPlan.validity_count}} days validity</p> -->
                             <div class="emploe_section">
                                 <div class="no_monther">
                                    <h4>No. of Months</h4>
                                    <mat-form-field appearance="outline" style="width: 150px;">
                                        <mat-select placeholder="No of month" [(ngModel)]="noOfMonths" (ngModelChange)="changeMonths($event)">
                                            <mat-option [value]="1">
                                                1 month
                                            </mat-option>
                                            <mat-option [value]="2">
                                                2 months
                                            </mat-option>
                                            <mat-option [value]="3">
                                                3 months
                                            </mat-option>
                                            <mat-option [value]="4">
                                                4 months
                                            </mat-option>
                                            <mat-option [value]="5">
                                                5 months
                                            </mat-option>
                                            <mat-option [value]="6">
                                                6 months
                                            </mat-option>
                                            <mat-option [value]="7">
                                                7 months
                                            </mat-option>
                                            <mat-option [value]="8">
                                                8 months
                                            </mat-option>
                                            <mat-option [value]="9">
                                                9 months
                                            </mat-option>
                                            <mat-option [value]="10">
                                                10 months
                                            </mat-option>
                                            <mat-option [value]="11">
                                                11 months
                                            </mat-option>
                                            <!-- <mat-option [value]="12">
                                                12 months
                                            </mat-option> -->
                                        </mat-select>
                                    </mat-form-field>
                                    
                                 </div>
                                 <div class="ad_number">
                                    <h4>No. of Employees</h4>
                                    <div class="no-of-employees-stepper" style="display: flex; align-items: center;">
                                      
                                      <button [disabled]="noOfEmployees == 1" (click)="changeNoOfEmployees(0)" mat-icon-button style="    border: 1px solid #ddd;
                                      background: none;
                                      cursor: pointer;
                                      width: 30px;
                                      height: 30px;
                                      padding: 0px;
                                      display: flex;
                                      color: #6a6a6a;
                                      align-items: center;
                                      justify-content: center;">
                                        <mat-icon>remove</mat-icon>
                                      </button>
                                      
                                      <div style="width: 70px; text-align: center;padding: 5px 0px;margin: 0px 10px;">
                                        <input  smDecimalOnly  type="number" [(ngModel)]="noOfEmployees" style="width: 100%; text-align: center;     color: #6a6a6a; border: 1px solid #ccc; border-radius: 4px;" disabled />
                                      </div>
                                      
                                      <button (click)="changeNoOfEmployees(1)" mat-icon-button style="    border: 1px solid #ddd;
                                      background: none;
                                      cursor: pointer;
                                      width: 30px;
                                      height: 30px;
                                      padding: 0px;
                                      display: flex;
                                      align-items: center;
                                      color: #6a6a6a;
        
                                      justify-content: center;">
                                        <mat-icon>add</mat-icon>
                                      </button>
                                      
                                    </div>
                                  </div>

                             </div>
                             <div class="sed_button" *ngIf="countryInfo.currency == 'INR'">
                            <button flat type="button" (click)="onContinue()">Checkout</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                           <p style="margin-bottom: 25px;">Purchase using PayPal or Debit/Credit card.</p>
                           <sm-paypal-employee-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-employee-subscription-purchase>
                           </div>
                             <p>* No refund if pack used.</p>
                             <p>* No refund after 7 days of purchase.</p>
                             <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                             <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                             <div class="secr_check_secu">
                                <p>
                                   <mat-icon>lock</mat-icon>
                                   Safe & Secure checkout.
                                </p>
                             </div>
                          </div>
                    </div>
                 </div>
              </div>
             <!-- -------------------- 1 year business pack --------------------- -->
              <div class="row" *ngIf="selectedPlan.perUnitCost > 0 && selectedPlan.validity_count == 365">
                <div class="col-sm-7">
                    <div class="create_employees_ben">
                        <!-- <div class="wht_headinght">
                            <h3>Employee Pack Features</h3>
                            <p>The feature and functionality listed below will be available with this employee pack. </p>
                        </div>
                        <div class="assistant_benf">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Most easy and quickest on-boarding.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Track your employee activity in real time.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Check duty hours, login and logout with location.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Communicate via inbuilt messaging system.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Booking operation by employees.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Bill/Invoice generation by employees.
                                    </div>
                                  
                                </div>
                                <div class="col-sm-6">
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Purchase reminder and purchase record add.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Inventory item use and finish update.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Manage and record employee salary.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Record employee advance payments and credits.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Get the employee performance data in one click.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        View and analyze revenue generation by employees.
                                    </div>
                                   
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                 <div class="col-sm-5">
                    <div class="choose_sucri emsection">
                          <div class="nus_nu_sectionm">
                            <div class="create_thy">
                             <h3>{{selectedPlan.title}}</h3>
                             <!-- <p class="prev_heading">Premium support & troubleshoot</p> -->
                             <p>You can buy this pack for any number of employees at once. This way you can save money too over monthly pack.</p>
                            </div>
                             <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                             <h4>per employee for 365 days</h4>
                             <!-- <p>{{selectedPlan.validity_count }} days validity</p> -->
                             <div class="emploe_section">
                                 <div class="ad_number">
                                    <h4>No. of Employees</h4>
                                    <div class="no-of-employees-stepper" style="display: flex; align-items: center;">
                                      
                                      <button [disabled]="noOfEmployees == 1" (click)="changeNoOfEmployees(0)" mat-icon-button style="    border: 1px solid #ddd;
                                      background: none;
                                      cursor: pointer;
                                      width: 30px;
                                      height: 30px;
                                      padding: 0px;
                                      display: flex;
                                      color: #6a6a6a;
                                      align-items: center;
                                      justify-content: center;">
                                        <mat-icon>remove</mat-icon>
                                      </button>
                                      
                                      <div style="width: 70px; text-align: center;padding: 5px 0px;margin: 0px 10px;">
                                        <input  smDecimalOnly  type="number" [(ngModel)]="noOfEmployees" style="width: 100%; text-align: center;     color: #6a6a6a; border: 1px solid #ccc; border-radius: 4px;" disabled />
                                      </div>
                                      
                                      <button (click)="changeNoOfEmployees(1)" mat-icon-button style="    border: 1px solid #ddd;
                                      background: none;
                                      cursor: pointer;
                                      width: 30px;
                                      height: 30px;
                                      padding: 0px;
                                      display: flex;
                                      align-items: center;
                                      color: #6a6a6a;
        
                                      justify-content: center;">
                                        <mat-icon>add</mat-icon>
                                      </button>
                                      
                                    </div>
                                  </div>

                             </div>
                             <div class="sed_button" *ngIf="countryInfo.currency == 'INR'">
                            <button flat type="button" (click)="onContinue()">Checkout</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                           <p style="margin-bottom: 25px;">Purchase using PayPal or Debit/Credit card.</p>
                           <sm-paypal-employee-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-employee-subscription-purchase>
                           </div>
                             <p>* No refund if pack used.</p>
                             <p>* No refund after 7 days of purchase.</p>
                             <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                             <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                             <div class="secr_check_secu">
                                <p>
                                   <mat-icon>lock</mat-icon>
                                   Safe & Secure checkout.
                                </p>
                             </div>
                          </div>
                    </div>
                 </div>
              </div>
             <!-- ------------------- Free business trial pack -------------------- -->
              <div class="row" *ngIf="selectedPlan.perUnitCost == 0 && selectedPlan.validity_count == 30">
                <div class="col-sm-7">
                    <div class="create_employees_ben">
                        <!-- <div class="wht_headinght">
                            <h3>Employee Pack Features</h3>
                            <p>The feature and functionality listed below will be available with this employee pack. </p>
                        </div>
                        <div class="assistant_benf">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Most easy and quickest on-boarding.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Track your employee activity in real time.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Check duty hours, login and logout with location.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Communicate via inbuilt messaging system.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Booking operation by employees.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Bill/Invoice generation by employees.
                                    </div>
                                  
                                </div>
                                <div class="col-sm-6">
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Purchase reminder and purchase record add.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Inventory item use and finish update.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Manage and record employee salary.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Record employee advance payments and credits.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        Get the employee performance data in one click.
                                    </div>
                                    <div class="cardfg_se">
                                        <mat-icon>check</mat-icon>
                                        View and analyze revenue generation by employees.
                                    </div>
                                   
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                 <div class="col-sm-5">
                    <div class="choose_sucri emsection">
                          <div class="nus_nu_sectionm">
                            <div class="create_thy">
                             <h3>{{selectedPlan.title}}</h3>
                             <p>Add up to 5 employees for free for one month. You have to opt for paid pack once the free subscription is over to continue collaboration with employees. </p>
                            </div>
                            <!-- ₹ -->
                             <h1>{{selectedPlan.currency_symbol}}{{selectedPlan.perUnitCost.toFixed(2)}} </h1>
                             <h4>5 employees for 30 days </h4>
                             <!-- <p>{{selectedPlan.validity_count}} days validity</p> -->
                             <div class="emploe_section"></div>
                             <div class="sed_button">
                            <button flat type="button" (click)="onContinue()">Start free trial</button>
                         </div>
                          <div class="paypal-sheet" *ngIf="showPaypalSheet">
                           <sm-paypal-employee-subscription-purchase
                              [parentdata]="subscriptionDataToSend"
                              (close)="closePaypalSheet($event)"
                           ></sm-paypal-employee-subscription-purchase>
                           </div>
                             <p>* No refund. </p>
                             <p>* One time use.</p>
                             <p>* No debit/credit card required.</p>
                             <!-- <p>Contrary to popular belief, Lorem Ipsum is not simply random text. literature from  years old. </p> -->
                             <!-- <p class="normal_uio">making this the first true generator on the Internet.</p> -->
                             <div class="secr_check_secu">
                                <p>
                                   <mat-icon>lock</mat-icon>
                                   Safe & Secure checkout.
                                </p>
                             </div>
                          </div>
                    </div>
                 </div>
              </div>
              </mat-card>
              <!-- <mat-card appearance="outlined" *ngIf="!selectedPlan || selectedPlan == 'null'">
                <div class="row">
                   <div class="col-sm-7">
                      <div class="create_business_ben">
                            <div class="wht_headinght">
                               <h3 style="font-weight: normal;">Select a pack to get the details.</h3>
                               <p>Here are the options of Packs to add a new employee or recharge an existing one.   <br>
                                Once you select one, the details about the pack and it's features will appear below.</p>
                            </div>
                      </div>
                   </div>
                </div>            
              </mat-card> -->
           </div>
    </div>
</div>
